import { IFreeRounds } from '@/mainComponent/store/interfaces/IFreeRounds';
import { IAchievement } from '@/mainComponent/store/interfaces/IAchievement';
import { ITournament } from '@/mainComponent/store/interfaces/ITournament';
import { ITournamentFreeSpin } from '@/mainComponent/store/interfaces/ITournamentFreeSpin';
import { IAchievementBG } from '@/mainComponent/store/interfaces/IAchievementBG';
import { IAchievementFS } from '@/mainComponent/store/interfaces/IAchievementFS';
import { Prediction } from '@/mainComponent/items/Prediction';
import { PromoComponent } from '@/mainComponent/PromoComponent';

class PromoStore {
  static events = {
    SET_TOURNAMENT_DATA: 'STORE.SET_TOURNAMENT_DATA',
    SET_ACHIEVEMENT_COUNTER: 'STORE.SET_ACHIEVEMENT_COUNTER'
  };

  constructor() {
    this.prediction = new Prediction();
  }

  freeRounds: IFreeRounds | null;
  achievement: IAchievement | null;
  tournament: ITournament | null;
  tournamentPlayers: { score: number; place: number; prize: number; player: string }[] = [];
  tournamentFreeSpin: ITournamentFreeSpin | null;
  achievementBG: IAchievementBG | null;
  achievementFS: IAchievementFS | null;

  isStartTournament: boolean = false;

  isAchievement: boolean = false;
  isTournament: boolean = false;
  isFreeSpinsTournament: boolean = false;
  isFreeRounds: boolean = false;

  // achievement data
  freeSpinsWin: boolean = false;
  freeSpinsWinInOtherGame: boolean = false;
  isFreeSpinsPopup: boolean = false;
  isPopupFreeSpinsOtherGame: boolean = false;
  isPopupFinishGame: boolean = false;
  isOtherGame: boolean = false;
  isToolTipOnce: boolean = false;

  betFreeSpinGame: number = 0;
  isPopupOtherGameOnesTournament: boolean = false;
  isPopupOtherGameOnesAchievement: boolean = false;
  isPopupOnesAchievement: boolean = false;
  isStartPromo: boolean = false;
  isStartGameForPromo: boolean = false;
  isStartAchievement: boolean = false;

  // freeSpins data tournament
  startFreeSpins: boolean = false;
  protected isShowStartFreeSpins: boolean = false;
  isFinishFreeSpins: boolean = false;
  startFreeSpinsOtherGame: boolean = false;
  protected isStartFreeSpinsOtherGame: boolean = false;
  isOtherGameTournament: boolean = false;

  // counter for achievement
  achievementCounterLeft: number = 0;
  achievementCounterTotal: number = 0;

  // prize game for achievement
  isPrizeGameWin: boolean = false;
  isPrizeGameWinOtherGame: boolean = false;
  isFinishedPrizeGame: boolean = false;
  isAchievementBG: boolean = false;
  isAchievementFS: boolean = false;

  // freeRounds data
  isStartFreeRounds: boolean = false;
  isFinishFreeRounds: boolean = false;
  isStartFreeRoundsOnce: boolean = false;

  wagerType: string = '';
  wagerData: any;

  prediction: Prediction;

  setData(data: any): void {
    if (data?.freeRounds) {
      this.setFreeRounds = data.freeRounds;
    }

    if (data?.achievement?.rewardsTotal && this.isAchievement) {
      this.achievementCounterLeft = data.achievement.rewardsLeft;
      this.achievementCounterTotal = data.achievement.rewardsTotal;
      (<IAchievement>this.achievement).rewardsLeft = this.achievementCounterLeft;
      (<IAchievement>this.achievement).rewardsTotal = this.achievementCounterTotal;
      game.emit(PromoStore.events.SET_ACHIEVEMENT_COUNTER);
    }

    //  This terrible crutch was made because they do not give time to remake the protocol for promo))
    if (data?.achievement?.tournament) {
      this.tournamentFreeSpin = data.achievement;
    } else if (
      data?.achievement?.lines &&
      !data?.achievement?.reward?.isAchievementBG &&
      !data?.achievement?.reward?.isAchievementsFSandFR
    ) {
      // временный костыль, пока не подчиниться сервер, нужен в случае когда время ачивки истекло, но сервер в нечении нескоторого времени продолжает слать данные по ним
      if (this.isFinishedPromo(data.achievement.time.closedAt)) return;

      this.setAchievement = data.achievement;
    } else if (data?.achievement?.reward?.isAchievementBG) {
      // временный костыль, пока не подчиниться сервер, нужен в случае когда время ачивки истекло, но сервер в нечении нескоторого времени продолжает слать данные по ним
      if (this.isFinishedPromo(data.achievement.time.closedAt)) return;

      this.setAchievementBG = data.achievement;
    } else if (data?.achievement?.reward?.isAchievementsFSandFR) {
      // временный костыль, пока не подчиниться сервер, нужен в случае когда время ачивки истекло, но сервер в нечении нескоторого времени продолжает слать данные по ним
      if (this.isFinishedPromo(data.achievement.time.closedAt)) return;

      this.setAchievementFS = data.achievement;
    }

    if (data?.tournament) {
      // временный костыль, пока не подчиниться сервер, нужен в случае когда время турнира истекло, но сервер в нечении нескоторого времени продолжает слать данные по ним
      const deltaTime = (new Date((<ITournament>data.tournament).closedAt).getTime() - new Date().getTime()) / 1000;
      if (deltaTime <= 0) return;

      this.setTournament = data.tournament;
    }

    if (data?.players) {
      this.tournamentPlayers = data.players;
      game.emit(PromoStore.events.SET_TOURNAMENT_DATA);
    }

    this.isFreeSpinsTournament = Boolean(this.tournamentFreeSpin);

    this.setStatesAchievement();
    this.setStatesAchievementPrizeGame();
    this.setStatesFreeSpins();
    this.setStatesFreeRounds();
  }

  protected setStatesAchievement(): void {
    if (!this.isAchievement) return;

    const {
      progress,
      reward: { roundsLeft, gid, rounds },
      betOption,
      denomination,
      lines
    } = <IAchievement>this.achievement;
    // @ts-ignore
    const { total, current } = progress.rounds || progress.wins || progress.bets;
    this.isOtherGame = this.otherGame(gid);

    this.freeSpinsWin = Number(total) <= Number(current) && Number(total) > 0 && roundsLeft >= 0; // показывает находимся ли мы во фриспин игре
    this.freeSpinsWinInOtherGame = this.isOtherGame && this.freeSpinsWin; // показывает находимся ли мы во фриспин игре в другой игре
    this.isPopupFreeSpinsOtherGame = roundsLeft === rounds && this.isOtherGame; // флажок чтоб показать попап что в другой игре мы выиграли фриспины
    this.isFreeSpinsPopup = roundsLeft === rounds && !this.isOtherGame && roundsLeft !== null; // флажок чтоб показать попап что мы выиграли фриспины (в этой игре)
    this.isPopupFinishGame = roundsLeft === 0; // флажок чтоб показать попап что закончились фриспины
    this.betFreeSpinGame = betOption * denomination * lines;
    if (game.fsm.currentPhaseName === 'waitSpin') game.emit(PromoComponent.events.MAIN_FLOW_EXECUTE);
  }

  protected setStatesAchievementPrizeGame(): void {
    if (!this.isAchievementBG && !this.isAchievementFS) return;

    const {
      betOption,
      denomination,
      lines,
      progress,
      reward: { gid, roundsLeft }
    } = <IAchievementBG>this.achievementBG || <IAchievementFS>this.achievementFS;
    // @ts-ignore
    const { total, current } = progress.rounds || progress.wins || progress.bets;
    const inPrizeGame: boolean = this.isAchievementBG
      ? (<IAchievementBG>this.achievementBG).reward.inBonusGame
      : (<IAchievementFS>this.achievementFS).reward.inFreeSpinGame;

    this.isOtherGame = this.otherGame(gid);
    this.isPrizeGameWin = Number(total) <= Number(current) && !this.isOtherGame && !inPrizeGame;
    this.isPrizeGameWinOtherGame = Number(total) <= Number(current) && this.isOtherGame;
    this.isFinishedPrizeGame = inPrizeGame && !this.isOtherGame;
    this.betFreeSpinGame = betOption * denomination * lines;
  }

  protected setStatesFreeSpins(): void {
    if (!this.isFreeSpinsTournament) return;

    const {
      reward: { gid, roundsLeft },
      denomination,
      lines,
      betOption
    } = <ITournamentFreeSpin>this.tournamentFreeSpin;
    this.isOtherGameTournament = this.otherGame(gid);
    this.startFreeSpins = !this.isOtherGameTournament && !this.isShowStartFreeSpins;
    this.isFinishFreeSpins = roundsLeft === 0;
    this.startFreeSpinsOtherGame = this.isOtherGameTournament && !this.isStartFreeSpinsOtherGame;
    this.betFreeSpinGame = betOption * denomination * lines;
  }

  protected setStatesFreeRounds(): void {
    if (!this.isFreeRounds) return;

    this.isStartFreeRounds = !this.isStartFreeRoundsOnce && (<IFreeRounds>this.freeRounds).roundsLeft > 0;
    this.isFinishFreeRounds = (<IFreeRounds>this.freeRounds).roundsLeft === 0;
    this.betFreeSpinGame = (<IFreeRounds>this.freeRounds).bet;
  }

  protected isFinishedPromo(time: string): boolean {
    return (new Date(time).getTime() - new Date().getTime()) / 1000 <= 0;
  }

  protected otherGame(gameName: number): boolean {
    return gameName != initConfig.gameIdentificationNumber;
  }

  hasPromoApp(): boolean {
    // @ts-ignore
    return Boolean(window?.promoApp);
  }

  isFreeSpinsGame(): boolean {
    return this.isFreeSpinsGameAchievement() || this.isFreeSpinsGameTournament() || this.isFreeRoundsGame();
  }

  isPrizeGame(): boolean {
    if (!this.isAchievementBG && !this.isAchievementFS) return false;

    return this.isPrizeGameWin;
  }

  isPrizeState(): boolean {
    return this.isFreeSpinsGame() || this.isPrizeGame();
  }

  isFreeSpinsGameAchievement(): boolean {
    if ((!this.isAchievement && !this.isAchievementBG && !this.isAchievementFS) || this.isOtherGame) return false;

    const {
      reward: { roundsLeft, rounds }
    } = this.achievement || this.achievementBG || <IAchievementFS>this.achievementFS;
    return roundsLeft <= rounds && roundsLeft !== 0 && roundsLeft !== null;
  }

  isFreeSpinsGameTournament(): boolean {
    if (!this.tournamentFreeSpin) return false;

    const {
      reward: { roundsLeft, rounds }
    } = this.tournamentFreeSpin;
    return roundsLeft <= rounds && roundsLeft !== 0 && roundsLeft !== null;
  }

  isFreeRoundsGame(): boolean {
    if (!this.isFreeRounds) return false;

    return (<IFreeRounds>this.freeRounds).roundsLeft > 0;
  }

  isProgressGame(): boolean {
    return this.isProgressGameAchievement() || this.isProgressGameAchievementBG();
  }

  isProgressGameAchievement(): boolean {
    if (!this.isAchievement) return false;

    const { progress } = <IAchievement>this.achievement;
    // @ts-ignore
    const { total, current } = progress.rounds || progress.wins || progress.bets;
    return Number(total) > Number(current);
  }

  resetAchievement(): void {
    this.setAchievement = null;
    this.setAchievementBG = null;
    this.setAchievementFS = null;
    this.isShowPopupFreeSpinsOtherGameAchievement = false;
    this.isShowPopupFreeSpinsAchievement = false;
    this.statusToolTip = false;
    this.isStartedPromo = false;
    this.achievementCounterLeft = 0;
    this.achievementCounterTotal = 0;
    this.isStartAchievement = false;
  }

  resetTournament(): void {
    this.setTournament = null;
    this.tournamentFreeSpin = null;
    this.isShowPopupFreeSpinsOtherGameTournament = false;
    this.tournamentPlayers = [];
    this.isStartedPromo = false;
    this.statusToolTip = false;
    this.setIsStartFreeSpinsOtherGame = false;
    this.setIsShowStartFreeSpins = false;
    this.isStartTournament = false;
  }

  resetFreeRounds(): void {
    this.setFreeRounds = null;
    this.isStartFreeRoundsOnce = false;
    this.isFinishFreeRounds = false;
  }

  isProgressGameAchievementBG(): boolean {
    if (!this.isAchievementBG) return false;

    const { progress } = <IAchievementBG>this.achievementBG;
    // @ts-ignore
    const { total, current } = progress.rounds || progress.wins || progress.bets;
    return Number(total) > Number(current);
  }

  isProgressGameAchievementFS(): boolean {
    if (!this.isAchievementFS) return false;

    const { progress } = <IAchievementFS>this.achievementFS;
    // @ts-ignore
    const { total, current } = progress.rounds || progress.wins || progress.bets;
    return Number(total) > Number(current);
  }

  isProgressTournament(): boolean {
    if (!this.isTournament) return false;

    return (<ITournament>this.tournament).stage !== 'finished';
  }

  isBetProperly(bet: number) {
    if (!this.isAchievement && !this.isAchievementBG && !this.isAchievementFS && !this.isTournament) return false;

    if (this.isTournament) {
      const minBet = (<ITournament>this.tournament).rules.minBet;
      return bet >= minBet && this.isValidTournamentGame();
    } else {
      const { minBet, maxBet } = this.achievement || this.achievementBG || <IAchievementFS>this.achievementFS;
      return bet >= minBet && bet <= maxBet;
    }
  }

  isFullAchievementProgress(achievement: any, current = undefined): boolean {
    if (!achievement) return false;

    const condition: string = Object.entries(achievement.progress)[0][0];

    const currentStep: number =
      // @ts-ignore
      typeof current === 'number' ? current : Number(achievement.progress[condition]?.current);
    return (
      // @ts-ignore
      currentStep >= Number(achievement.progress[condition]?.total)
    );
  }

  isValidTournamentGame(): boolean {
    if (!this.isTournament) return false;

    return (<ITournament>this.tournament).rules.games.some(({ id }) => initConfig.gameIdentificationNumber == id);
  }

  isValidTournamentFreeRoundsGame(): boolean {
    if (!this.isTournament) return false;

    return (<ITournamentFreeSpin>this.tournamentFreeSpin).reward.gid == initConfig.gameIdentificationNumber;
  }

  get activeAchievement() {
    switch (true) {
      case this.isAchievement:
        return this.achievement;
      case this.isAchievementFS:
        return this.achievementFS;
      case this.isAchievementBG:
        return this.achievementBG;
      default:
        return false;
    }
  }

  set isShowPopupFreeSpinsOtherGameTournament(status: boolean) {
    this.isPopupOtherGameOnesTournament = status;
  }

  set isShowPopupFreeSpinsOtherGameAchievement(status: boolean) {
    this.isPopupOtherGameOnesAchievement = status;
  }

  set isShowPopupFreeSpinsAchievement(status: boolean) {
    this.isPopupOnesAchievement = status;
  }
  set isStartedPromo(status: boolean) {
    this.isStartPromo = status;
  }

  set statusToolTip(status: boolean) {
    this.isToolTipOnce = status;
  }

  get store() {
    return game.store;
  }

  get isMainGameIdle(): boolean {
    return game.fsm.currentStateName === 'IDLE';
  }

  set setAchievement(achievement: IAchievement | null) {
    this.achievement = achievement;
    this.isAchievement = Boolean(this.achievement);
  }

  set setAchievementBG(achievement: IAchievementBG | null) {
    this.achievementBG = achievement;
    this.isAchievementBG = Boolean(this.achievementBG);
  }

  set setAchievementFS(achievement: IAchievementFS | null) {
    this.achievementFS = achievement;
    this.isAchievementFS = Boolean(this.achievementFS);
  }

  set setTournament(tournament: ITournament | null) {
    this.tournament = tournament;
    this.isTournament = Boolean(this.tournament);
  }

  set setFreeRounds(freeRounds: IFreeRounds | null) {
    this.freeRounds = freeRounds;
    this.isFreeRounds = Boolean(this.freeRounds);
  }

  set setIsShowStartFreeSpins(status: boolean) {
    this.isShowStartFreeSpins = status;
  }

  set setIsStartFreeSpinsOtherGame(status: boolean) {
    this.isStartFreeSpinsOtherGame = status;
  }
}
export { PromoStore };
